import {
	Breadcrumbs,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogProps,
	Typography,
} from "@material-ui/core";
import { FC, useState } from "react";
import { DialogTitle } from "src/components/CheckPro/DialogTitle";
import { useProjectsOT } from "src/hooks/redux/useProjectsOT";

export const RemoveSheetDialogOT: FC<DialogProps> = (
	props
) => {
	const { selected, remove, set } = useProjectsOT();
	const [isRemoving, setIsRemoving] = useState(false);

	const handleRemove = async () => {
		if (!selected.sheet) return;

		setIsRemoving(true);
		try {
			await remove.place.sheet(selected.sheet);

			// Limpiar la selección
			set.sheet(null);

			// Cerrar el modal
			props.onClose?.({}, "escapeKeyDown");

			// El elemento se eliminará automáticamente del listado
			// ya que el Redux state se actualiza tras la eliminación exitosa
		} catch (error) {
			console.error("Error al eliminar checklist:", error);
		} finally {
			setIsRemoving(false);
			// Cerrar el modal incluso si hay error
			props.onClose?.({}, "escapeKeyDown");
		}
	};

	return (
		<Dialog {...props} disableBackdropClick={isRemoving}>
			<DialogTitle
				onClose={isRemoving ? undefined : props.onClose}
				bigText="Eliminar Checklist"
				smallText={
					<Breadcrumbs>
						<Typography>
							{selected.project?.Nombre}
						</Typography>
						<Typography>
							{selected.checklist?.Nombre}
						</Typography>
						<Typography>
							{selected.assignedPlace?.Nombre}
						</Typography>
					</Breadcrumbs>
				}
			/>

			<DialogContent>
				<Typography>
					¿Estás seguro de que deseas eliminar este
					Checklist? Esto no se puede deshacer.
				</Typography>
			</DialogContent>

			<DialogActions>
				<Button
					disabled={isRemoving}
					onClick={() =>
						props.onClose?.({}, "escapeKeyDown")
					}
				>
					Cancelar
				</Button>

				<Button
					color="primary"
					variant="contained"
					disabled={isRemoving}
					onClick={handleRemove}
					startIcon={
						isRemoving ? (
							<CircularProgress size={20} color="inherit" />
						) : undefined
					}
				>
					{isRemoving ? "Eliminando..." : "Eliminar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
